import './Terms.css'

function Terms() {
  return (
    <div className='terms' >
        <div className="page">
            <div className="con">
                <div className="content">
                    <div className="title">
                        <div className="text">
                            <h1>Booking and Reservations</h1>
                        </div>
                        <div className="top">
                            <div className="one">
                                <ul className="list p-0 m-0">
                                    <li>Reservations can be made through our website, mobile application or by contacting our WhatsApp number at +2 01111119411</li>
                                </ul>
                            </div>
                            <div className="one">
                                <h3>Pricing and Payment</h3>
                                <ul className="list p-0 m-0">
                                    <li>All payments is made using online payment gateways.</li>
                                    <li>Accepted payment methods: Visa and MasterCard.</li>
                                </ul>
                            </div>
                            <div className="one">
                                <h3>Cancellations and Refunds</h3>
                                <ul className="list p-0 m-0">
                                    <li>All cancellations made more than 3 hours before the scheduled pick-up time are free of cancellation fees.</li>
                                    <li>Cancellation fees will apply to all cancellations made within 3 hours of the scheduled pick-up time.</li>
                                    <li>Refunds for cancellations outside the specified timeframe may be subject to a cancellation fee.</li>
                                    <li>Refunds will be issued using the original payment method, unless otherwise agreed upon.</li>
                                </ul>
                            </div>
                            <div className="one">
                                <h3>No-Shows</h3>
                                <ul className="list p-0 m-0">
                                    <li>No-shows, where the customer fails to appear for the scheduled service without prior notice, are non-refundable.</li>
                                </ul>
                            </div>
                            <div className="one">
                                <h3>Service Disruptions or Failures</h3>
                                <ul className="list p-0 m-0">
                                    <li>In the event of service disruptions or failures due to unforeseen circumstances (e.g., vehicle breakdown, severe weather conditions), we will make reasonable efforts to provide an alternative solution or reschedule the service.</li>
                                    <li>If alternative arrangements cannot be made, a refund for the disrupted or failed service will be issued.</li>
                                </ul>
                            </div>
                            <div className="one">
                                <h3>Promotional or Discounted Bookings</h3>
                                <ul className="list p-0 m-0">
                                    <li>Refunds for promotional or discounted bookings may be subject to specific terms and conditions outlined at the time of booking.</li>
                                </ul>
                            </div>
                            <div className="one">
                                <h3>Vehicle Safety and Maintenance</h3>
                                <ul className="list p-0 m-0">
                                    <li>Our vehicles undergo regular maintenance for safety and cleanliness.</li>
                                    <li>Our drivers are licensed professionals who adhere to traffic laws.</li>
                                </ul>
                            </div>
                            
                            <div className="one">
                                <h3>Privacy and Data Protection</h3>
                                <ul className="list p-0 m-0">
                                    <li>Customer data is handled in accordance with applicable privacy laws.</li>
                                    <li>Customer information is used solely for service purposes and may be shared with necessary third-party service providers.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Terms